import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";
import { useIntl } from "react-intl";

const ContextTable = ({ heading, points }) => {
  const intl = useIntl();

  return (
    <div className={styles.contextTable} dir="auto">
      <h5 className={styles.TableHeading}>
        {intl.formatMessage({
          id: heading,
          defaultMessage: heading,
        })}
      </h5>
      <ul className={styles.TableUL}>
        {points.map((item, index) => (
          <li className={styles.TableLI} key={index}>
            {intl.formatMessage({
              id: item,
              defaultMessage: item,
            })}
          </li>
        ))}
      </ul>
    </div>
  );
};

// Define the expected props for the component
ContextTable.propTypes = {
  heading: PropTypes.string.isRequired,
  points: PropTypes.arrayOf(PropTypes.string),
};

export default ContextTable;
